import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// campfire
import {
  AppointmentsService,
  ICreateAppointmentPayload,
  ITimeSlotsParams,
  LoggerService
} from '@campfire-nx/api';

import { APPOINTMENT_BOOKING_TOPICS } from '@open-portal-app/help/constants/help.constants';

export interface IAppointmentDetails {
  topic: string;
  option: string;
  entity?: string | null;
  entity_ref?: string | null;
  raptorSource?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  details!: IAppointmentDetails;

  constructor(
    private router: Router,
    private appointmentsService: AppointmentsService,
    private loggerService: LoggerService
  ) { }

  start(appointmentDetails?: IAppointmentDetails) {
    this.router.navigate(['/appointments'], { state: appointmentDetails || APPOINTMENT_BOOKING_TOPICS.contactUs, replaceUrl: true });
  }

  getList() {
    return this.appointmentsService.list()
      .then((response: any) => {
        return response;
      })
      .catch((err) => {
        this.loggerService.error('AppointmentService', 'getList', { error: err });
      });
  }

  getTimeslots(params: ITimeSlotsParams): Promise<any> {
    return new Promise((resolve) => {
      return this.appointmentsService.timeslots(params)
        .then(response => resolve(response))
        .catch(err => {
          const { error } = err
          this.loggerService.error('AppointmentService', 'getTimeslots', error);
          resolve(error);
        });
    })
  }

  createAppointment(payload: ICreateAppointmentPayload) {
    return this.appointmentsService.create(payload)
      .then(response => response)
      .catch((error) => {
        this.loggerService.error('AppointmentService', 'createAppointment', error);
        return error;
      });
  }
}
